import React from 'react';
import styles from './Header.module.css';
import { useAuth } from '../../context/AuthContext';

function Header(): React.ReactElement {
  const { user, logout } = useAuth();
  return (
    <header className={styles.header}>
      <span className={styles.logo}>
        <span className={styles.logoAccent}>Conductor</span>
      </span>
      <span className={styles.tagline}>REST UI Builder</span>
      <span style={{marginLeft:'auto',fontSize:12,color:'#c9d1d9'}}>{user?.displayName || user?.username} ({user?.role === 'admin' ? 'Administrator' : 'User'}) <button onClick={()=>void logout()} style={{marginLeft:12}}>Sign out</button></span>
    </header>
  );
}

export default Header;
